export default __webpack_public_path__ + "static/media/Jira.4068fd5c.webp";